import React from "react";
export const ExportStatusAlert = ({ error }: { error?: string }) => error ? <div className="tw-rounded-lg tw-border tw-border-red-200 tw-bg-red-50 tw-p-4 tw-text-sm tw-text-red-700" role="alert">{error}</div> : null;
